<template>
  <div class="auditlog froala_editor fr-box fr-document fr-ltr fr-basic fr-top">
    <el-scrollbar class="auditlog_el">
      <div
        class="each_auditlog_log"
        v-for="(item,index) in historyRecordList"
      >
        <div class="each_auditlog_time">{{item.createtime | formatTime}}</div>
        <div
          class="audit_log_person"
          style="margin-bottom:6px;"
        >
          <img
            v-if='!item.head_img'
            src="../../../static/img/avatar.png"
            alt=""
          >
          <img
            :src="item.head_img"
            alt=""
            v-if='item.head_img'
          >
          <span
            class="name"
            style="margin-left:10px;"
          >{{item.username}}</span>
        </div>
        <div
          class="audit_log_person"
          style="margin-bottom:6px;"
        >
          <span
            class="editor_article"
            style="margin-left:0px;"
            v-if="item.op_type === 0"
          >创建了文章</span>
          <span
            class="editor_article"
            style="margin-left:0px;"
            v-if="item.op_type === 1"
          >编辑了文章</span>
          <span
            class="open_history_list"
            v-show="item.op_type !==0 && !isOpenCurrentHistory[index]"
            @click.stop='openCurrentHistory(index)'
          >展开</span>
          <span
            class="open_history_list"
            v-show="item.op_type !==0 && isOpenCurrentHistory[index]"
            @click.stop='openCurrentHistory(index)'
          >折叠</span>
        </div>

        <div
          class="history_list_content article_detail_content"
          :class="[isOpenCurrentHistory[index] ? 'history_list_content_open' : 'history_list_content_close']"
        >
          <div
            class="each_history_list_content"
            v-for="itemcontent in item.revision"
          >
            <div class="fr-wrapper">
              <div
                class="fr-element fr-view"
                v-html="itemcontent"
              >
              </div>
            </div>

          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { getUrlCode } from '../../../utils/index.js'
import * as api from '../../../api'
export default {
  name: 'editorhistory',
  data () {
    return {
      isOpenCurrentHistory: []
    }
  },
  created () {

  },
  components: {

  },
  computed: {
    historyRecordList () {
      return this.$store.state.logs.historyRecordList
    }
  },
  mounted () {


  },
  destroyed () {

  },
  methods: {
    // returnCurrentArticle(item) {
    //   var option = {
    //     ...this.$store.getters.baseOption,
    //     "params": {                       // 必须字段： 文章参数
    //       "id": item.id       // 必须字段： 版本 Diff 的 ID
    //     }
    //   }
    //   api._post(_TEMPORARYURL_ + 'log_article_version/article_diff_recover', option).then((resp) => {
    //     if (resp.code == 200) {
    //       this.$parent.$parent.restoreCurrentArticle(resp.data.content)
    //     }
    //   }).catch((error) => {
    //     console.log(error)
    //   })
    // }
    openCurrentHistory (index) {
      if (this.isOpenCurrentHistory[index]) {
        this.$set(this.isOpenCurrentHistory, index, false)
      } else {
        this.$set(this.isOpenCurrentHistory, index, true)
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/audit_comment.styl'

@media (min-width: 992px)
  .fr-box.fr-document .fr-wrapper
    padding 10px
    min-width 0px
    background #fff
    text-align center

@media (min-width: 992px)
  .fr-box.fr-document .fr-wrapper .fr-element
    margin-top 0px !important
    margin-bottom 0 !important
    padding 0
    min-height 0px !important
    width 100%

@media (min-width: 992px)
  .fr-box.fr-document
    min-width 0

.audit_log_person
  .open_history_list
    margin-left 10px
    color rgba(104, 142, 255, 1)
    font-weight 400
    font-size 14px
    line-height 36px
    cursor pointer

.history_list_content
  .each_history_list_content
    box-sizing border-box
    margin-bottom 10px
    padding 10px
    width 100%
    border 1px solid rgba(219, 224, 236, 1)
    border-top 1px solid rgba(219, 224, 236, 1) !important
    box-shadow 0 1px 1px #eaeaea
    color #606266
    word-break break-all
    font-size 14px
    line-height 20px

.history_list_content_close
  overflow hidden
  max-height 200px

.history_list_content_open
  width 100%
  height auto
</style>
